import styled from '@emotion/styled';
import {LogoText} from './text';
import logo from 'assets/img/logo.png';
import logoSmall from 'assets/img/logo-small.png';

const LogoImg = styled(p => <img src={logoSmall} alt="" {...p} />)({
  display: 'flex',
  width: 53,
  height: 26,
});

export const LogoWhite = styled(p => (
  <div {...p}>
    <LogoImg />
    <LogoText
      style={{
        fontSize: 22,
      }}>
      Le Club
    </LogoText>
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const LogoGold = styled(p => <img src={logo} alt="" {...p} />)({
  display: 'flex',
  margin: 'auto',
  width: 177,
  height: 86,
  marginBottom: 94,
  marginTop: 51,
});
